import axios from "../../../utils/axios";
import moment from "moment";
import { useState, useEffect } from "react";
import CustomerCardMeter from "../../../components/Customer/Cards/CustomerCardMeter";
import DateRangePicker from "../../../components/DateRangePicker";
import Layout from "../../../components/Layout";
import PageTitle from "../../../components/PageTitle";
import { channelController } from "../../../controllers/channelController";
import { toast } from "react-hot-toast";
import ViewProjectMeter from "../../../components/ProjectManager/ProjectMeter/Modals/ViewProjectMeter";
import TableSkimmer from "../../../components/TableSkimmer";
import { useSelector } from "react-redux";
import AssignMeter from "../../../components/Meter/modals/AssignMeter";
import AssignedMetersTable from "../../../components/CustomerManager/Tables/AssignedMetersTable";
import MeterInfoModal from "../../../components/Meter/modals/MeterInfoModal";
import { errorBlock } from "../../../controllers/errorBlock";
import { Button, Input } from "antd";
const CustomerManagerDashboard = () => {
  const [tabstate, settabstate] = useState(1);
  const [inputname, setinputname] = useState("");

  const [count, setCount] = useState([]);
  const [startDate, setStartDate] = useState(
    moment(Date.now()).subtract("1", "year").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(Date.now()).format("YYYY-MM-DD")
  );

  const siteDetails = useSelector((state) => state.projectSite);
  const userDetails = useSelector((state) => state.userDetails);

  const [loading, setloading] = useState(true);
  const [assignmodal, setassignmodal] = useState(false);
  const [modal, setmodal] = useState(false);
  const [details, setdetails] = useState(null);
  const [data, setData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [assignedcount, setassignedcount] = useState(0);
  const [recall, setrecall] = useState(false);
  const [infomodal, setinfomodal] = useState(false);
  const [meternumber, setmeternumber] = useState("");
  const [nometercount, setnometercount] = useState(0);
  const [customercount, setcustomercount] = useState(0);

  // get all customer count
  useEffect(() => {
    (async () => {
      try {
        let res = await axios.post(`/customer/getallmetercustomerscount`, {
          zone: Number(siteDetails.siteid),
          column: "agent",
          columnparameter: userDetails.username,
        });
        setcustomercount(res.data.count);
      } catch (error) {
        errorBlock(error);
      }
    })();
  }, []);

  // count of customer without meter
  useEffect(() => {
    (async () => {
      try {
        let res = await axios.post(
          `/customer/getallcustomeraccountswithoutmeter`,
          {}
        );
        setnometercount(res.data.meta.count);
      } catch (error) {
        errorBlock(error);
      }
    })();
  }, []);

  // get all customer analytics
  useEffect(() => {
    (async () => {
      try {
        let res = await axios.post(
          `/customer/getallmetercustomersbyzone`,
          // `/customer/getallmetercustomeraccountsbycustomermanagerandzone`,
          {
            zone: Number(siteDetails?.siteid),
          }
        );
        let result = channelController(res);
        if (result.type !== "success") {
          toast[result.type](result.message);
          setloading(false);
          return;
        }
        setData(result.message.body);
        setassignedcount(result.message.meta.count);
        setloading(false);

        // setcustomercount(res.data.count);
      } catch (error) {
        errorBlock(error);
        setloading(false);
      }
    })();
  }, [recall]);

  const filteredData = data.filter(
    (i) =>
      i.address.toLowerCase().trim().includes(inputname.toLowerCase()) ||
      i.agent.toLowerCase().trim().includes(inputname.toLowerCase()) ||
      i.assigner.toLowerCase().trim().includes(inputname.toLowerCase()) ||
      i.customerclass.toLowerCase().trim().includes(inputname.toLowerCase()) ||
      i.customerid.toLowerCase().trim().includes(inputname.toLowerCase()) ||
      i.firstname.toLowerCase().trim().includes(inputname.toLowerCase()) ||
      i.lastname.toLowerCase().trim().includes(inputname.toLowerCase()) ||
      i.metermodel.toLowerCase().trim().includes(inputname.toLowerCase()) ||
      i.meter.toLowerCase().trim().includes(inputname.toLowerCase())
  );

  return (
    <Layout>
      {modal && (
        <ViewProjectMeter open={modal} setopen={setmodal} details={details} />
      )}

      {assignmodal && (
        <AssignMeter
          refresh={setrecall}
          setopen={setassignmodal}
          user={null}
          open={assignmodal}
        />
      )}

      {infomodal && (
        <MeterInfoModal
          meterNumber={meternumber}
          setopen={setinfomodal}
          open={infomodal}
        />
      )}

      <div className="w-full bg-white rounded-md drop-shadow-md px-2 mb-10">
        <div className="my-2 p-2 flex items-start justify-between">
          <PageTitle
            title={`Overview of customers with meters in (${siteDetails.sitename})`}
          />
          <div className="flex items-center">
            {/* <hr className="my-4" /> */}
            <DateRangePicker
              setEndDate={setEndDate}
              setStartDate={setStartDate}
              refreshBtn={setRefresh}
              desc={""}
            />
            <Button
              className="!bg-secondary !text-white"
              onClick={() => {
                setassignmodal(true);
              }}
            >
              Assign Meter
            </Button>
          </div>
        </div>

        <div className="border rounded-md py-3">
          <div className="grid grid-cols-3 gap-10 mx-auto w-[90%] p-3">
            <CustomerCardMeter
              title={"Customers with Meters"}
              caption={"Count customer in your project site with meter."}
              value={assignedcount}
              type={"withmeters"}
            />
            <CustomerCardMeter
              title={"Customer without meters"}
              caption={"Count customer in your project site without meter."}
              value={nometercount}
              type={"withoutmeters"}
            />
          </div>
        </div>

        {/* table and graph */}
        <div className="hidden justify-end">
          <div className="mt-4 px-3 mb-4">
            <div className="flex p-1 w-[fit-content] bg-gray-200 rounded-md items-center">
              <div
                onClick={() => settabstate(1)}
                className={
                  tabstate == 1
                    ? `bg-white rounded-md text-[14px] px-2 py-1 text-center cursor-pointer`
                    : `text-center cursor-pointer px-2 py-1 text-[14px]`
                }
              >
                Table
              </div>
              <div
                onClick={() => settabstate(2)}
                className={
                  tabstate == 2
                    ? `bg-white rounded-md px-2 py-1 text-[14px] text-center cursor-pointer`
                    : `text-center cursor-pointer text-[14px] px-2 py-1 `
                }
              >
                Chart
              </div>
            </div>
          </div>
        </div>

        {/* <Rule /> */}
        <div className="p-3 overflow-x-auto overflow-y-hidden">
          <div className="flex mb-3 items-center justify-end">
            <Input
              size=""
              onChange={(e) => setinputname(e.target.value)}
              className=" block placeholder:font-light !w-[200px]"
              placeholder="Search for a customer ..."
            />
          </div>
          {tabstate == 1 &&
            (loading ? (
              <TableSkimmer entries={12} />
            ) : (
              <AssignedMetersTable
                data={filteredData}
                refresh={setrecall}
                setinfomodal={setinfomodal}
                setmeternumber={setmeternumber}
              />
            ))}
        </div>
      </div>
    </Layout>
  );
};

export default CustomerManagerDashboard;
